import $ from "../../libs/jquery-3.3.1.min.js"
import {CustomWiggle, CustomEase, gsap} from "../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras'
import {BaseMiniGame} from "./BaseMiniGame";
import {AppearingInteractiveButton} from "./components/AppearingInteractiveButton";
import {GameTambour_Note} from "./components/GameTambour_Note";

const MAX_LIVES = 10;
const LIVE_FILL_INITIAL_X = 68;

// Game description : Tambour
export class GameTambour extends BaseMiniGame {

  // Constructor
  constructor(data) {
    super(data);
    this.appWidth = this.data.appDimensions.width;
    this.appHeight = this.data.appDimensions.height;

    this.$screenEl = null;

    this.lives = [];
    this.currentLives = MAX_LIVES;
    this.tutorialNotes = [];
    this.notes = [];
    this.currentState = "instructions";
    this.requestedNote = 'center'
    this.success = false;

    this.timelineTilesSpacing = 298;
    this.isInGame = false;
    this.turorialTrackSpeed = -8;
    this.partitionTrackSpeed = -(200 / this.timelineTilesSpacing); // a tile passes once every 400ms so we need to move X pixels per second

    this.countdownTimer = {currentTime: 3};

    this.hitVolume = 1;
    this.mainTrackVolume = 0;
    this.lastMetronomePosition = 0;

    this.hitZonePosRange = { // the center of a note needs to be between these values to be considered correct
      min: 0,
      max: 360
    }

    this.goodHitPosRange = { // the center of a note needs to be between these values to be considered correct
      min: 50,
      max: 305
    }

    this.hitSounds = {
      left: null,
      center: null,
      right: null,
    }

    this.hitSoundsDelta = {
      left: 0,
      center: 0,
      right: 0,
    }

    this.countdownTextStyle = new PIXI.TextStyle({
      align: "center",
      fill: "#00156B",
      fontFamily: "Sketchnote Text",
      fontSize: 90
    });
  }

  async assetLoader() {
    await super.assetLoader();

    if (this.data.medias && this.data.medias.length) {
      for (let i = 0; i < this.data.medias.length; i++) {
        const data = (this.data.medias[i].url.endsWith(".svg")) ? {parseAsGraphicsContext: true} : {};
        this.assets[this.data.medias[i].name] = await PIXI.Assets.load({src: this.data.medias[i].url, data: data});
      }
    }

    this.hitSounds.left = [
      new Howl({
        src: ["audio/tambour-left_v2.wav"],
        loop: false,
        autoplay: false,
        volume: 1,
      }),
      // new Howl({
      //   src: ["audio/tambour-left-2-faded.wav"],
      //   loop: false,
      //   autoplay: false,
      //   volume: 1,
      // }),
      // new Howl({
      //   src: ["audio/tambour-left-3-faded.wav"],
      //   loop: false,
      //   autoplay: false,
      //   volume: 1,
      // })
    ];

    this.hitSounds.center = [
      new Howl({
        src: ["audio/tambour-center_v2.wav"],
        loop: false,
        autoplay: false,
        volume: 1,
      }),
      // new Howl({
      //   src: ["audio/tambour-center-2-faded.wav"],
      //   loop: false,
      //   autoplay: false,
      //   volume: 1,
      // }),
      // new Howl({
      //   src: ["audio/tambour-center-3-faded.wav"],
      //   loop: false,
      //   autoplay: false,
      //   volume: 1,
      // })
    ];

    this.hitSounds.right = [
      new Howl({
        src: ["audio/tambour-right_v2.wav"],
        loop: false,
        autoplay: false,
        volume: 1,
      }),
      // new Howl({
      //   src: ["audio/tambour-right-2-faded.wav"],
      //   loop: false,
      //   autoplay: false,
      //   volume: 1,
      // }),
      // new Howl({
      //   src: ["audio/tambour-right-3-faded.wav"],
      //   loop: false,
      //   autoplay: false,
      //   volume: 1,
      // })
    ];

    this.metronomeSound = new Howl({
      src: ["audio/tambour-metronome.wav"],
      loop: false,
      autoplay: false,
      volume: 1,
    });

    this.mainTrack = new Howl({
      src: [this.data.sounds["tambour_full_track"]],
      loop: false,
      autoplay: false,
      volume: this.mainTrackVolume,
    });
  }


  async buildStage() {

    this.$screenEl = $(this.canvas).parents(".screen");

    // Left Area
    this.leftAreaContainer = new PIXI.Container();
    this.leftAreaContainer.position.set(55, 370)

    this.leftAreaBackground = new PIXI.Sprite(this.assets["interface-left-bg"]);
    this.leftAreaContainer.addChild(this.leftAreaBackground);

    this.visualDrum = new PIXI.Container();
    this.visualDrum.position.set(this.leftAreaBackground.width / 2, this.leftAreaBackground.height / 2);

    this.visualDrumBg = new PIXI.Sprite(this.assets["drum-base"]);
    this.visualDrumBg.anchor.set(0.5);
    this.visualDrum.addChild(this.visualDrumBg);

    this.visualDrumLeftHit = new PIXI.Sprite(this.assets["drum-left-hit"]);
    this.visualDrumLeftHit.anchor.set(0.5);
    this.visualDrumLeftHit.alpha = 0;
    this.visualDrum.addChild(this.visualDrumLeftHit);

    this.visualDrumCenterHit = new PIXI.Sprite(this.assets["drum-center-hit"]);
    this.visualDrumCenterHit.anchor.set(0.5);
    this.visualDrumCenterHit.alpha = 0;
    this.visualDrum.addChild(this.visualDrumCenterHit);

    this.visualDrumRightHit = new PIXI.Sprite(this.assets["drum-right-hit"]);
    this.visualDrumRightHit.anchor.set(0.5);
    this.visualDrumRightHit.alpha = 0;
    this.visualDrum.addChild(this.visualDrumRightHit);

    this.leftAreaContainer.addChild(this.visualDrum);
    this.stage.addChild(this.leftAreaContainer);

    // Right area
    this.rightAreaContainer = new PIXI.Container();
    this.rightAreaContainer.position.set(510, 370)
    this.stage.addChild(this.rightAreaContainer);

    this.rightAreaBackground = new PIXI.Sprite(this.assets["interface-right-bg"]);
    this.rightAreaMask = new PIXI.Sprite(this.assets["interface-right-mask"]);
    this.rightAreaContainer.addChild(this.rightAreaBackground);
    this.rightAreaContainer.addChild(this.rightAreaMask);

    this.rightAreaContainer.mask = this.rightAreaMask;

    this.hitZoneGood = this.addHitZoneVisual("good");
    this.rightAreaContainer.addChild(this.hitZoneGood);
    this.hitZoneMiss = this.addHitZoneVisual("miss");
    this.rightAreaContainer.addChild(this.hitZoneMiss);

    this.baseTimelineOffset = 180;
    this.timelineBg = new PIXI.TilingSprite({
      texture: this.assets["timeline-tile"],
      width: this.rightAreaBackground.width,
      height: this.rightAreaBackground.height
    });
    this.timelineBg.tilePosition.x = this.baseTimelineOffset;
    this.rightAreaContainer.addChild(this.timelineBg);

    // Notes Partition
    this.partitionArea = new PIXI.Container();
    this.partitionArea.position.set(this.baseTimelineOffset, 0); // align with lines
    this.lastMetronomePosition = 20000; // arbitrary value that just needs to be bigger than timelineTilesSpacing so we trigger the metronome sound immediately on start

    const tutorialNotes = [null, null, null, null, null, "center", null, null, "left", null, null, "right"];
    for (let i = 0; i < tutorialNotes.length; i++) {
      if (tutorialNotes[i] === null) {
        continue;
      }

      let note = new GameTambour_Note(tutorialNotes[i], true, this);
      note.position.y = this.rightAreaBackground.height / 2 - note.image.height / 2;
      note.position.x = (i * this.timelineTilesSpacing) - note.width / 2;

      this.partitionArea.addChild(note);

      this.tutorialNotes.push(note);
    }

    for (let i = 0; i < this.data.partition.length; i++) {
      if (this.data.partition[i] === null) {
        continue;
      }

      let note = new GameTambour_Note(this.data.partition[i], false, this);
      note.position.y = this.rightAreaBackground.height / 2 - note.image.height / 2;
      note.position.x = (tutorialNotes.length * this.timelineTilesSpacing) + (i * this.timelineTilesSpacing) - note.width / 2;

      this.partitionArea.addChild(note);

      this.notes.push(note);
    }
    this.rightAreaContainer.addChild(this.partitionArea);

    // Success/fail label
    this.successLabel = {
      "fr": new PIXI.Sprite(this.assets[`game-success-fr`]),
      "en": new PIXI.Sprite(this.assets[`game-success-en`])
    };
    [this.successLabel.fr, this.successLabel.en].forEach((n) => {
      n.alpha = 0;
      n.scale.set(0.20);
      n.position.set(1350, 560);
      n.anchor.set(0.5, 0.5)
      this.stage.addChild(n);
    })

    this.failLabel = {
      "fr": new PIXI.Sprite(this.assets[`game-fail-fr`]),
      "en": new PIXI.Sprite(this.assets[`game-fail-en`])
    };
    [this.failLabel.fr, this.failLabel.en].forEach((n) => {
      n.alpha = 0;
      n.scale.set(0.20);
      n.position.set(1350, 560);
      n.anchor.set(0.5, 0.5)
      this.stage.addChild(n);
    })

    // Tutorial label
    this.tutorialLabel = {
      "fr": new PIXI.Sprite(this.assets[`tutorial-fr`]),
      "en": new PIXI.Sprite(this.assets[`tutorial-en`])
    };
    [this.tutorialLabel.fr, this.tutorialLabel.en].forEach((n) => {
      n.alpha = 0;
      n.scale.set(0.20);
      n.position.set(1135, 375);
      n.anchor.set(0.5, 0.5)
      this.stage.addChild(n);
    })

    // Countdown
    this.countdownContainer = new PIXI.Container();
    this.countdownContainer.position.set(686, 561);

    const countdownBg = new PIXI.Graphics().circle(0, 0, 160 / 2).fill(0xFFFFFF);
    this.countdownContainer.addChild(countdownBg);

    this.countdownText = new PIXI.Text({
      text: "3",
      style: this.countdownTextStyle,
    });

    this.countdownText.anchor.set(0.5, 0.5);
    this.countdownContainer.addChild(this.countdownText);

    this.countdownContainer.alpha = 0;

    this.stage.addChild(this.countdownContainer);

    // Lives container
    this.livesAreaContainer = new PIXI.Container();
    this.livesAreaContainer.position.set(1485, 145);

    this.livesAreaBackground = new PIXI.Sprite(this.assets["life"]);
    this.livesAreaContainer.addChild(this.livesAreaBackground);

    this.livesFill = new PIXI.Sprite(this.assets["life-fill"]);
    this.livesFill.anchor.set(0, 0.5);
    this.livesFill.position.set(LIVE_FILL_INITIAL_X, 57);
    this.livesAreaContainer.addChild(this.livesFill);

    const liveFillMask = new PIXI.Graphics(this.assets["life-mask"]);
    liveFillMask.position.set(336, 37);
    liveFillMask.width = 257;
    liveFillMask.height = 39;
    this.livesAreaContainer.addChild(liveFillMask);
    this.livesFill.mask = liveFillMask;

    this.stage.addChild(this.livesAreaContainer);

    // Timer area
    this.timerArea = new PIXI.Container();
    this.timerArea.position.set(this.rightAreaContainer.position.x, this.rightAreaContainer.position.y + this.rightAreaBackground.height + 60);

    let timerAreaBg = new PIXI.Graphics().roundRect(0, 0, this.rightAreaBackground.width, 22, 22 / 2).fill(0x586AA5);
    this.timerArea.addChild(timerAreaBg);

    this.timerBarContainer = new PIXI.Container();
    this.timerArea.addChild(this.timerBarContainer);

    this.timerIcon = new PIXI.Sprite(this.assets["timer-icon"]);
    this.timerIcon.anchor.set(0, 0.5);
    this.timerIcon.position.set(0, this.timerArea.height / 2);
    this.timerArea.addChild(this.timerIcon);

    this.timerBarRoundedRadius = 11;

    this.timerBar = new PIXI.Graphics().rect(0, 0, this.timerIcon.width - (this.timerBarRoundedRadius * 2), this.timerBarRoundedRadius * 2).fill(0x00156B);
    this.timerBar.position.x = this.timerBarRoundedRadius; // offset a little to the right so it doesn't cut the left radius

    this.timerBarEndTip = new PIXI.Graphics().circle(0, 0, this.timerBarRoundedRadius).fill(0x00156B);
    this.timerBarEndTip.position.set(this.timerIcon.width - this.timerBarRoundedRadius, this.timerBarRoundedRadius);
    this.timerBarContainer.addChild(this.timerBar, this.timerBarEndTip);

    this.stage.addChild(this.timerArea);

    this.initEvents();
  }

  addHitZoneVisual(type) {
    let zone = new PIXI.Container();
    zone.position.set(175, this.rightAreaBackground.height / 2);

    zone.centerEl = new PIXI.Sprite(this.assets[`hit-zone-${type}`]);
    zone.centerEl.anchor.set(0.5, 0.5);
    zone.centerEl.position.set(0, 0);

    let color = 0xFFFFFF;

    if (type == "good") {
      color = 0x00156b
    } else {
      color = 0xDB2655
    }

    zone.circle1 = new PIXI.Graphics().circle(0, 0, (zone.centerEl.width / 2)).stroke({width: 4, color: color});
    zone.addChild(zone.circle1);
    zone.circle2 = new PIXI.Graphics().circle(0, 0, (zone.centerEl.width / 2)).stroke({width: 4, color: color});
    zone.addChild(zone.circle2);

    zone.addChild(zone.centerEl);

    // Feedback words
    zone.feedback = {
      "fr": new PIXI.Sprite(this.assets[`feedback-${type}-fr`]),
      "en": new PIXI.Sprite(this.assets[`feedback-${type}-en`])
    };
    [zone.feedback.fr, zone.feedback.en].forEach((n) => {
      n.alpha = 0;
      n.scale.set(0.20);
      n.position.set(180, -120);
      n.anchor.set(0.5, 0.5)
      zone.addChild(n);
    })

    zone.alpha = 0;

    return zone;
  }

  initEvents() {
    let keyMap = {
      65: "left", // a
      83: "center", // s
      68: "right", // d
    }

    $(document).keydown((e) => {
      if (this.isInGame) {
        if (keyMap.hasOwnProperty(e.keyCode)) {
          this.hitDrum(keyMap[e.keyCode]);
        }
      }
    });

    //add listener
    this.ticker.add(this.progress.bind(this));
  }

  hitDrum(position) {
    // Make sure the screensaver delay is reset when we hit a note because we are not touching the screen
    app.resetTimer();

    // console.log(this.currentState);
    if (this.currentState === "instructions") {
      let $target = this.$screenEl.find(`.demo-tambour .tambour-hit-note.${position}`);

      gsap.fromTo($target,
        {
          opacity: 1,
        }, {
          opacity: 0,
          overwrite: "auto",
          duration: 1,
          ease: "power2.out"
        }
      );

      this.playNote(position);

    } else if (this.currentState === "tutorial") {
      this.highlightGameNote(position);

      // check current note position and check if it's in the right section
      for (let i = 0; i < this.tutorialNotes.length; i++) {
        if (this.tutorialNotes[i].isCurrentNote && !this.tutorialNotes[i].hasPassed) {
          const centerPosX = this.tutorialNotes[i].getCenterPosition();

          if (centerPosX >= this.goodHitPosRange.min && centerPosX <= this.goodHitPosRange.max) {
            // Note is in center, now check if the correct note has been hit
            if (this.tutorialNotes[i].type === position) {
              console.log("GOOD note hit!");
              this.showNoteStatus("good");

              this.tutorialNotes[i].isCurrentNote = false;
              this.tutorialNotes[i].hasPassed = true;

              if (this.isAllTutorialNotesDone()) {
                // tutorial is complete. Let's start the real game
                this.currentState = "game";

                // Hide Tutorial label
                gsap.to(this.tutorialLabel[app.i18n.lang], {
                  pixi: {
                    alpha: 0,
                    scale: 0.8,
                  },
                  duration: 0.35
                });

                this.countdown(() => this.startGame());
              }

            } else {
              console.log("Note in center but wrong note! We'll wait for correct hit.");
              this.showNoteStatus("miss");
            }
          } else {
            // Should not be here technically as if the note is not in the hit zone it won't trigger
            console.log("BAD");
            this.showNoteStatus("miss");
          }
        }
      }

    } else if (this.currentState === "game") {
      this.highlightGameNote(position);

      // check current note position and check if it's in the right section
      for (let i = 0; i < this.notes.length; i++) {
        if (this.notes[i].isCurrentNote && !this.notes[i].hasPassed) {
          const centerPosX = this.notes[i].getCenterPosition();

          if (centerPosX >= this.goodHitPosRange.min && centerPosX <= this.goodHitPosRange.max) {
            // Note is in center, now check if the correct note has been hit
            if (this.notes[i].type === position) {
              console.log("GOOD note hit!");
              this.showNoteStatus("good");

              this.notes[i].isCurrentNote = false;
              this.notes[i].hasPassed = true;

              // if (this.isAllNotesDone()) {
              //   // game is completed
              //   console.log("Song completed!");
              //
              //
              // }

              return;
            } else {
              console.log("Note in center but wrong note!");
              this.showNoteStatus("miss");
              setTimeout(() => this.playNote(this.requestedNote), 250);
              this.notes[i].isCurrentNote = false;
              this.notes[i].hasPassed = true;
              this.currentLives--;
              this.updateLives();
            }
          } else {
            console.log("Note was not in center when hit");
            this.showNoteStatus("miss");
            this.playNote(this.requestedNote)
            this.notes[i].isCurrentNote = false;
            this.notes[i].hasPassed = true;
            this.currentLives--;
            this.updateLives();
          }
        }
      }
    }
  }

  updateLives() {

    const targetX = LIVE_FILL_INITIAL_X - (1 - this.currentLives / MAX_LIVES) * this.livesFill.mask.width;
    // this.livesFill.position.set(targetX, this.livesFill.position.y)
    gsap.to(this.livesFill, {
      pixi: {
        x: targetX,
      },
      duration: 0.3,
      ease: "power2.out"
    })

    if (this.currentLives === 0) {
      console.log("No more lives... failed.");
      this.endGame();
    }
  }

  isAllTutorialNotesDone() {
    let completedCount = 0;

    for (let i = 0; i < this.tutorialNotes.length; i++) {
      if (this.tutorialNotes[i].hasPassed) {
        completedCount++;
      }
    }

    return completedCount == this.tutorialNotes.length;
  }

  isAllNotesDone() {
    let completedCount = 0;

    for (let i = 0; i < this.notes.length; i++) {
      if (this.notes[i].hasPassed) {
        completedCount++;
      }
    }

    return completedCount == this.notes.length;
  }

  highlightGameNote(position) {

    let target = null;
    if (position === "left") {
      target = this.visualDrumLeftHit

    } else if (position === "center") {
      target = this.visualDrumCenterHit

    } else if (position === "right") {
      target = this.visualDrumRightHit
    }

    gsap.fromTo(target,
      {
        alpha: 1,
      }, {
        alpha: 0,
        overwrite: "auto",
        duration: 1,
        ease: "power2.out"
      }
    );

    this.playNote(position);
  }

  playNote(position) {
    const delta = this.hitSoundsDelta[position];
    this.hitSounds[position][delta].seek(0).play();
    this.hitSoundsDelta[position] = (this.hitSoundsDelta[position] + 1) % this.hitSounds[position].length;
  }

  showNoteStatus(type) {
    const target = (type === "good") ? this.hitZoneGood : this.hitZoneMiss;
    const otherHitZone = (type === "good") ? this.hitZoneMiss : this.hitZoneGood;

    if (target.hitTimeline) {
      target.hitTimeline.kill()
      target.hitTimeline = null;
    }

    target.hitTimeline = gsap.timeline({});

    target.hitTimeline.to([target, target.centerEl],
      {
        pixi: {
          alpha: 1,
        },
        duration: 0.1,
        overwrite: "auto",
      }, 0);

    target.hitTimeline.fromTo([target.circle1, target.circle2],
      {
        pixi: {
          scale: 0.8,
          alpha: 1,
        }
      },
      {
        pixi: {
          scale: 1,
          alpha: 0,
        },
        ease: "power2.out",
        duration: 1,
        stagger: 0.15,
        overwrite: "auto",
      }, 0);

    target.hitTimeline.to(target.centerEl,
      {
        pixi: {
          alpha: 0,
        },
        duration: 0.1,
        overwrite: "auto",
      }, "-=0.5");

    Object.keys(otherHitZone.feedback).forEach((language) => {
      const sprite = target.feedback[language];
      target.hitTimeline.set(sprite, {pixi: {alpha: 0}});
    })

    Object.keys(target.feedback).forEach((language) => {
      const sprite = target.feedback[language];

      if (language === app.i18n.lang) {
        target.hitTimeline.fromTo(sprite,
          {
            pixi: {
              alpha: 0,
              scale: 0.1
            }
          },
          {
            pixi: {
              alpha: 1,
              scale: 0.20
            },
            duration: 0.1,
            overwrite: "auto",
          }, 0);

        target.hitTimeline.to(sprite,
          {
            pixi: {
              alpha: 0,
              scale: 0.25
            },
            duration: 0.1,
            overwrite: "auto",
          }, "-=0.5");

      } else {
        target.hitTimeline.set(sprite, {pixi: {alpha: 0}});
      }
    })
  }

  countdown(callback) {
    gsap.to(this.countdownContainer,
      {
        pixi: {
          alpha: 1
        },
        overwrite: "auto",
        duration: 0.25,
        ease: "power2.out"
      }
    );

    this.countdownTimer.currentTime = 3;
    this.countdownText.text = this.countdownTimer.currentTime;

    this.decrementTimer(() => {
      console.log("Timer complete");

      gsap.to(this.countdownContainer,
        {
          pixi: {
            alpha: 0
          },
          overwrite: "auto",
          duration: 0.25,
          ease: "power2.out"
        }
      );

      callback();
    });
  }

  decrementTimer(callback) {

    gsap.to(this.countdownTimer, {
      duration: 1,
      currentTime: this.countdownTimer.currentTime - 1,
      onComplete: () => {
        // TODO: use another sound for the timer ticker
        app.audio.play(app.settings.click_sound, app.settings.volume, true);
        // this.setTimeDisplay();
        this.countdownText.text = this.countdownTimer.currentTime;

        if (this.countdownText.text > 0) {
          this.decrementTimer(callback);
        } else {
          callback();
        }
      }
    })
  }

  closeInstructions() {
    if (this.currentState !== "transition") {
      this.currentState = "transition";

      this.$screenEl.find(".game-instructions").fadeOut();
      this.startGameTutorial();
    }
  }

  startGameTutorial() {

    // Show Tutorial label
    gsap.fromTo(this.tutorialLabel[app.i18n.lang], {
      pixi: {
        alpha: 0,
        scale: 0.2,
      }
    }, {
      pixi: {
        alpha: 1,
        scale: 1,
      },
      duration: 0.5
    });

    setTimeout(() => {
      console.log("starting tutorial");
      this.tutorialNotes[0].isCurrentNote = true;

      // activate the progression
      this.currentState = "tutorial";

    }, 500);
  }

  progress(ticker) {
    if (this.currentState === "tutorial") {

      let needsProgress = true;

      for (let i = 0; i < this.tutorialNotes.length; i++) {
        // First we need to check if we have a not in the hit zone and save it as the current note
        this.tutorialNotes[i].isCurrentNote = this.tutorialNotes[i].isInHitZone() && !this.tutorialNotes[i].hasPassedHitZone();

        if (this.tutorialNotes[i].isCurrentNote && !this.tutorialNotes[i].hasPassed) {
          const centerPosX = this.tutorialNotes[i].getCenterPosition();

          // In the tutorial we need to stop on the note so the person has time to hit it and learn how to play
          if ((centerPosX - (this.tutorialNotes[i].image.width / 2) <= 76)) {
            needsProgress = false;
          }
        }
      }

      if (needsProgress) {
        this.partitionArea.position.x += (this.turorialTrackSpeed * ticker.deltaTime);
        this.timelineBg.tilePosition.x += (this.turorialTrackSpeed * ticker.deltaTime);

        // Play metronome sound when the dotted line is centered
        if (this.partitionArea.position.x - this.lastMetronomePosition <= -(this.timelineTilesSpacing - 4)) {
          this.lastMetronomePosition = this.partitionArea.position.x;
          this.metronomeSound.seek(0).play();
        }
      }

    } else if (this.currentState === "game") {
      let needsProgress = true;

      for (let i = 0; i < this.notes.length; i++) {
        // First we need to check if we have a not in the hit zone and save it as the current note
        if (this.notes[i].isInHitZone() && !this.notes[i].hasPassedHitZone()) {
          this.notes[i].isCurrentNote = true;
          this.requestedNote = this.notes[i].type;
        } else {
          this.notes[i].isCurrentNote = false;
        }

        if (this.notes[i].isCurrentNote && !this.notes[i].hasPassed) {
          const centerPosX = this.notes[i].getCenterPosition();

          // In the game, if the note went too far, it counts as a miss
          if ((centerPosX < this.goodHitPosRange.min)) {
            console.log("note went too far! Count as miss.");
            this.notes[i].hasPassed = true;
            this.showNoteStatus("miss");
            this.playNote(this.requestedNote)
            this.currentLives--;
            this.updateLives();
          }
        }
      }

      if (this.isAllNotesDone()) {
        // game is completed
        console.log("Song completed!");
        this.success = true;
        this.endGame();
        // needsProgress = false;
      }

      if (needsProgress) {
        this.partitionArea.position.x += (this.partitionTrackSpeed * ticker.deltaMS);
        this.timelineBg.tilePosition.x += (this.partitionTrackSpeed * ticker.deltaMS);

        // Play metronome sound when the dotted line is centered
        if (this.partitionArea.position.x - this.lastMetronomePosition <= -(this.timelineTilesSpacing - 4)) {
          this.lastMetronomePosition = this.partitionArea.position.x;
          this.metronomeSound.seek(0).play();
        }
      }
    } else if (this.currentState === "ending") {
      // just continue rolling the timeline until we fadeout
      this.partitionArea.position.x += (this.partitionTrackSpeed * ticker.deltaMS);
      this.timelineBg.tilePosition.x += (this.partitionTrackSpeed * ticker.deltaMS);
    }
  }

  startGame() {
    this.currentState = "game";

    setTimeout(() => {
      this.mainTrack.fade(0, this.mainTrackVolume, 500);
      this.mainTrack.seek(0).play();

      gsap.fromTo(this.timerBar, {
          pixi: {
            width: this.timerIcon.width - (this.timerBarRoundedRadius * 2),
          },
        }, {
          pixi: {
            width: this.timerArea.width - (this.timerBarRoundedRadius * 2),
          },
          overwrite: "auto",
          duration: this.mainTrack.duration() - 2,
          ease: "none"
        }
      );

      gsap.fromTo(this.timerBarEndTip, {
          pixi: {
            x: this.timerIcon.width - this.timerBarRoundedRadius,
          },
        }, {
          pixi: {
            x: this.timerArea.width - this.timerBarRoundedRadius,
          },
          overwrite: "auto",
          duration: this.mainTrack.duration() - 2,
          ease: "none"
        }
      );
    }, 500);
  }

  endGame() {
    console.log("End game");
    this.currentState = "ending";

    this.mainTrack.fade(this.mainTrackVolume, 0, 3000);
    this.mainTrack.once("fade", () => {
      this.mainTrack.pause();
    });
    this.mainTrack.pause();

    gsap.to([this.partitionArea, this.timelineBg], {
        pixi: {
          alpha: 0,
        },
        overwrite: "auto",
        duration: 3,
        ease: "power2.out"
      }
    );

    // Show success/fail label

    if (this.success) {
      gsap.fromTo(this.successLabel[app.i18n.lang], {
        pixi: {
          alpha: 0,
          scale: 0.2,
        }
      }, {
        pixi: {
          alpha: 1,
          scale: 1,
        },
        duration: 0.5
      });
    } else {
      gsap.fromTo(this.failLabel[app.i18n.lang], {
        pixi: {
          alpha: 0,
          scale: 0.2,
        }
      }, {
        pixi: {
          alpha: 1,
          scale: 1,
        },
        duration: 0.5
      });
    }

    setTimeout(() => {
      if (this.success) {
        console.log("win")
        app.animateOutGame(5);
      } else {
        console.log("fail")
        app.animateOutGame(9);
      }
    }, 3000);

  }

  beforeAnimateIn() {
    // rebuild timeline

  }

  begin() {
    this.isInGame = true;
  }

  reset() {

    // reset values
    this.currentLives = MAX_LIVES;
    this.updateLives();

    this.currentState = "instructions";
    this.success = false;
    this.isInGame = false;

    gsap.killTweensOf(this.partitionArea);
    gsap.killTweensOf(this.timelineBg);
    this.partitionArea.alpha = 1;
    this.timelineBg.alpha = 1;

    // reset tutorial label
    gsap.set([this.tutorialLabel.fr, this.tutorialLabel.en], {
      pixi: {
        alpha: 0,
        scale: 0.2
      }
    })

    // reset success/fail label
    gsap.set([this.successLabel.fr, this.successLabel.en, this.failLabel.fr, this.failLabel.en], {
      pixi: {
        alpha: 0,
        scale: 0.2
      }
    })

    // reset positions
    this.partitionArea.position.set(this.baseTimelineOffset, 0); // align with lines
    this.lastMetronomePosition = 20000; // arbitrary value that just needs to be bigger than timelineTilesSpacing so we trigger the metronome sound immediately on start
    this.timelineBg.tilePosition.x = this.baseTimelineOffset;

    // Reset lifes
    gsap.killTweensOf(this.livesFill);
    this.livesFill.position.set(LIVE_FILL_INITIAL_X, 57);

    // reset timer bar
    gsap.killTweensOf(this.timerBar);
    gsap.killTweensOf(this.timerBarEndTip);
    this.timerBar.width = this.timerIcon.width - (this.timerBarRoundedRadius * 2);
    this.timerBarEndTip.position.x = this.timerIcon.width - this.timerBarRoundedRadius;

    // Audio
    this.mainTrack.off("fade");
    this.mainTrack.pause();

    // reset some states
    for (let i = 0; i < this.tutorialNotes.length; i++) {
      this.tutorialNotes[i].reset();
    }

    for (let i = 0; i < this.notes.length; i++) {
      this.notes[i].reset();
    }

    this.$screenEl.find(".game-instructions").show();

  }

}
